import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
import "../library.css";
import { Link } from "react-router-dom";
import { GiCrownCoin } from "react-icons/gi";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { FiFilePlus } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import { MdOutlineDeleteForever } from "react-icons/md";
import { message } from 'antd';
import { FaRegWindowClose } from "react-icons/fa";
import CustomDropdown from "../../../../components/ModelsDropdown"


const LibraryTr = () => {

    const [data , setData] = useState([]);
    const [current , setCurrent] = useState("library");
    const [modelsData, setModelsData] = useState([]);
    const [modelsdDrop, setModelsDrop] = useState([]);
    const [delOpen , setDelOpen] = useState(false)
    const [delOneId , setDelOneId] = useState(null)
    const [poppoints , setPopPoints] = useState(false)
    const [pointsValue , setPointsValue] = useState('')
    const [editId , setEditId] = useState(null)
    const [addOpen , setaddOpen] = useState(false)
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [formInputs , setFormInputs] = useState({
          points:"",
          model3dId:"",
          model3dName:"",
        });

    const limit = 20; 
    const isFormValid = formInputs.points !== '' && formInputs.model3dId !== ''
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role
    

  const delSuccess = ()=>{
    message.success('Delete done');
  }

  const success = () => {
             message.success('Your Library Added Successfully');
    };

  const successSaved = () => {
             message.success('Your Point Edited Completely');
            };
  
  
  const getData = useCallback(async () => {
  if(current === "library"){
  try {
    const response = await api.get(`${API_BASE_URL}library`, {
      params: { page, limit },
    });
    setData( response.data?.items);
    setTotalPages(response.data.totalPages);
  } catch (err) {
    console.log("Error:", err);
  }}
  else if(current ==="model3D"){
    api.get(`${API_BASE_URL}projects-3dmodel`,{
      params: { page, limit },
    })
      .then(function (response) {
        setModelsData(response.data?.items);
        setTotalPages(response.data.totalPages);
      }).catch(error => {
        console.log("handlesubmit error for blog get ", error)
      });
  }
}, [page, limit, current]);

  useEffect(() => {
    getData();
  }, [getData]);
  
    const libraries =() => {
      setCurrent("library");
        setPage(1);
    }

    const model3D =() => {
        setCurrent("model3D");
        setPage(1);
    }
      const dropModel3D =() => {
      api.get(`${API_BASE_URL}projects-3dmodel/dropdown`)
      .then(function (response) {
        setModelsDrop(response.data)
      }).catch(error => {
        console.log("handlesubmit error for blog get ", error)
      });
    }

  
    // const models = ()=> { 
    // let oppmodels =[]
    //   for (let i = 0; i < modelsdDrop.length; i++) {
    // oppmodels.push(<option value={modelsdDrop[i].id} >{modelsdDrop[i].modelName}</option>)
    // }
    // return oppmodels
    //   }

    const confirmAdd = async ()=>{
             await api.post(`${API_BASE_URL}library`,{
                points: formInputs.points,
                model3d: formInputs.model3dId,
                })
              .then(function (response) {
                        console.log("handlesubmitffff  ", response.data)
                        success();
                        setaddOpen()
                        setData(response.data);
                        setFormInputs({
                          points: "",
                          model3dId: "",
                          model3dName: ""
                        })
                    // setData(response.data)
              }).catch(error => {
                console.log("handlesubmit error for blog get ", error)
              });   
    }


 const confirmDel = async (delOneId)=>{
    if (delOneId) {
      setDelOpen(false)
     await api.delete(`${API_BASE_URL}library/${delOneId}`)
      .then(function (response) {
          setData(response.data);
          delSuccess();
      }).catch(error => {
        console.log("handlesubmit error for blog ", error)
      });
  }
 }
  const confirmEdit = async (editId)=>{
    if (editId) {
        await api.patch(`${API_BASE_URL}library/${editId}`,{
              points: pointsValue,
              })
            .then(function (response) {
                      console.log("handlesubmitffff  ", response.data)
                      successSaved();
                      setPopPoints(false)
                      setData(response.data)
            }).catch(error => {
              console.log("handlesubmit error for blog get ", error)
            });   
  }
 }

 const pointsId =(id)=>{
  setPopPoints(true)
  setEditId(id)
 }

const delId =(id)=>{
  setDelOpen(true)
  setDelOneId(id)
 }
 const newModel = (e)=>{
  setFormInputs({...formInputs, model3dId: e.id, model3dName: e.modelName})
}

  return (
      <div className="h-fit w-full">
        <div className="libraryHeader">
          <div className="libraryH">
          <h1>3D Models Library</h1>
          {/* <div className="btnDev">
            <span>All Categories </span>
            <div className="btnImg"></div>
          </div> */}
          </div>
          <div className="libraryheaderImg"></div>
        </div>
        {/* library cards */}
               {role === "Admin" ? <div className="ChallangesTrNew">
                  <div className="flex">
                   <span className={current==="library" ? "trChActive" : "trChNoactive"} onClick={() => libraries()}>All Libraries</span>
                  <span className={current==="model3D" ? "trChActive" : "trChNoactive"} onClick={() => model3D()}>3D Models</span> 
                   </div>
                    {current === "library" ?
                    <div className="newChallenge" onClick={() => {setaddOpen(true)
                      dropModel3D()
                    }}>
                    <FiFilePlus className="addImg"/>
                    <span>Add Library</span>
                   </div> : null}
                   {current === "model3D" ?
                   <Link to={"/admin/tr/library/addmodel"}>
                    <div className="newChallenge">
                    <FiFilePlus className="addImg"/>
                    <span>Add 3D Model</span>
                   </div>
                   </Link> : null}
                   </div> : null}
        
        <div className="z-20 library-continar">
              {current === "library" && role === "Teacher" ? data.map(library => <Link to={`/admin/tr/library/print/${library.id}`} >
              <div>
            <div className="libraryCards" style={{backgroundImage:`url(${FILES_URL}${library?.model3d?.img?.url})`}}>
           <GiCrownCoin className="giCrownCoin"/> <span className="ptsSpan">{library.points} Points</span>
            </div>
                <div className="cardInImg">
              <div className="cardInfo">
                <h4 className="cardInfoH4">{library.model3d?.modelName} </h4>
              </div>
              </div>

          </div> </Link>) : null}
          {current === "library" && role === "Admin" ? data.map(library =>
              <div className="libraryPoints">
            <div className="libraryCards" style={{backgroundImage:`url(${FILES_URL}${library?.model3d?.img?.url})`}}>
            <div className="editPoints" onClick={()=> {pointsId(library.id)
              setPointsValue(library.points)
            }} ><GiCrownCoin className="giCrownCoin"/> <span className="ptsSpan">{library.points} Points</span></div>
            <MdOutlineDeleteForever className="deleteLib ml-auto" onClick={()=> {delId(library.id)}}/>
            </div>
                <div className="cardInImg">
              <div className="cardInfo">
                <h4 className="cardInfoH4">{library.model3d?.modelName} </h4>
              </div>
              </div>

          </div>) : null}

            {current === "model3D" && role === "Admin" ? modelsData.map(model =><Link to={`/admin/tr/library/modelprint/${model.id}`} >
              <div>
            <div className="libraryCards" style={{backgroundImage:`url(${FILES_URL}${model?.img.url})`}}>
            </div>
                <div className="cardInImg">
              <div className="cardInfo">
                <h4 className="cardInfoH4">{model?.modelName} </h4>
              </div>
              </div>
          </div> </Link>) : null}
        </div>

         { addOpen ? <div className="modal"> <div className="addNewLibrary w-[400px] h-[290px]">
            <button id="popIcon" onClick={()=>{setaddOpen(false)
                        setFormInputs({
                          points: "",
                          model3dId:"",
                          model3dName:"",
                        })
            }}>
            <FaRegWindowClose className="w-full h-full	"/>
          </button>
          <div className="addLibnpts">
            <label for="points">Points</label>
            <input type="number" className="inputWidth" id="points" value={formInputs.points} placeholder="Enter points"
             onChange={(e) =>setFormInputs({...formInputs, points: e.target.value})}/>
          </div>    
                <div className="addLibnpts">
        <label for="model3D">3D Model</label>
      <CustomDropdown options={modelsdDrop}
       selectedd={newModel}
       type="Select 3D Model"
       model3dId={formInputs.model3dId}
       model3dName={formInputs.model3dName}
       />

      </div>
            <div id="addCancel">
          <button className={modelsdDrop[0] ? "addorcancel" : "addNot"} disabled={!isFormValid} onClick={() => {confirmAdd()}}> Add </button>
          <button className="addorcancel" onClick={()=>{setaddOpen(false)
                    setFormInputs({
                          points: "",
                          model3dId:"",
                          model3dName:"",
                        })}}> Cancel </button> 
  </div>
            </div></div> : null}

        { poppoints ? <div className="modal"> <div className="addNewLibrary w-[350px] h-[200px]">
            <button id="popIcon" onClick={()=>{setPopPoints(false)}}>
            <FaRegWindowClose className="w-full h-full	"/>
          </button>
          <div className="addLibnpts">
            <label for="points">Points</label>
            <input type="number" className="inputWidth" id="points" value={pointsValue} placeholder="Enter points"
             onChange={(e) =>setPointsValue(e.target.value)}/>
          </div>    
          <div id="addCancel">
          <button className="addorcancel" onClick={() => {confirmEdit(editId)
          }}> Save </button> 
          <button className="addorcancel" onClick={()=>{setPopPoints(false)}}> Cancel </button> 
          </div>
            </div></div> : null}

        { delOpen ? <div className="modal"> <div id="delPopup">
            <button id="popIcon" onClick={()=>{setDelOpen(false)}}>
            <FaRegWindowClose className="w-full h-full	"/>
          </button>
          <div id="helpText"><span >Do you want to delete this one?</span></div>
          <div id="yesno">
          <button className="yesorno" onClick={() => {confirmDel(delOneId)}}> Yes </button> 
          <button className="yesorno" onClick={()=>{setDelOpen(false)}}> No </button> 
 </div>
          </div></div> : null}


        {!data[0] & current === "library" || !modelsData[0] & current === "model3D"  ?  null :
       <div className="flex items-center justify-center mt-6 mb-8 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}
      </div>      
  );
};

export default LibraryTr;
